import { render } from "./IndustryConsulting.vue?vue&type=template&id=6bb00128&scoped=true"
import script from "./IndustryConsulting.vue?vue&type=script&lang=js"
export * from "./IndustryConsulting.vue?vue&type=script&lang=js"

import "./IndustryConsulting.vue?vue&type=style&index=0&id=6bb00128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb00128"]])

export default __exports__